import { render } from "./tradingHall.vue?vue&type=template&id=233dabc4&scoped=true"
import script from "./tradingHall.vue?vue&type=script&lang=js"
export * from "./tradingHall.vue?vue&type=script&lang=js"

import "./tradingHall.vue?vue&type=style&index=0&id=233dabc4&lang=less&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233dabc4"]])

export default __exports__